/**
 * Helper for detecting file types with optimized performance
 */

// File extension constants (defined once for better performance)
const VIDEO_EXTENSIONS = new Set([
	"mp4",
	"webm",
	"ogg",
	"avi",
	"mov",
	"mkv",
	"flv",
	"wmv",
	"m4v",
	"3gp"
]);

const IMAGE_EXTENSIONS = new Set([
	"jpg",
	"jpeg",
	"png",
	"gif",
	"webp",
	"svg",
	"bmp",
	"ico",
	"tiff",
	"avif"
]);

// Cached regex for better performance
const EXTENSION_REGEX = /\.([^.]+)$/;

/**
 * Gets the file extension efficiently
 * @param fileName - File name or URL
 * @returns the extension in lowercase or empty string if none
 */
export const getFileExtension = (fileName: string): string => {
	if (!fileName || typeof fileName !== "string") {
		return "";
	}
	return EXTENSION_REGEX.exec(fileName)?.[1]?.toLowerCase() || "";
};

/**
 * Detects if a file is a video based on its extension
 * @param fileName - File name or URL
 * @returns true if it's a video file
 */
export const isVideoFile = (fileName: string): boolean => {
	const extension = getFileExtension(fileName);
	return VIDEO_EXTENSIONS.has(extension);
};

/**
 * Detects if a file is an image based on its extension
 * @param fileName - File name or URL
 * @returns true if it's an image file
 */
export const isImageFile = (fileName: string): boolean => {
	const extension = getFileExtension(fileName);
	return IMAGE_EXTENSIONS.has(extension);
};
